import React, { FC } from 'react'
import { MainImage, VerticalGrid } from './style'

//* utils
import { backgroundThemes, useCases } from '../../../constants/contentfulStyle.constant'
import { ComponentFlexibleHero } from '../../../models/components/flexibleHero'
import ImgUtil from '../../../utils/img.utils'
import formatInlineCode from '../../../utils/shortTextFormatting'

//* components
import Button from '../button'
import Typography from '../typography'
import WrapperImage from '../wrapperImage'

type Props = {
  data: ComponentFlexibleHero
  showBreadcrumbs: boolean
}

export const FlexibleHeroGrid: FC<Props> = ({ data, showBreadcrumbs }) => {
  const mainImageUrl = data.mainImage?.image?.file?.url || ''
  const logoUrl = data.logo?.image?.file?.url || ''
  const heroSubheadline = data.flexibleSubheadline || data.subheadline || ''

  const mainImage = (
    <WrapperImage
      src={ImgUtil.getResizedImageUrl(mainImageUrl, '')}
      width={data.useCase === useCases.CENTER ? 1200 : 588}
      height={data.useCase === useCases.CENTER ? 714 : 560}
      alt={data.mainImage?.altText}
      className="FlexibleHero__MainImage"
    />
  )

  const logo = (
    <WrapperImage
      className="FlexibleHero__Logo"
      src={ImgUtil.getResizedImageUrl(logoUrl, '')}
      width={253}
      height={107}
      alt={data.logo?.altText}
    />
  )

  const cta = (
    <div className="FlexibleHero__Buttons">
      {data.cta?.map((button: any, i: number) => (
        <span className="FlexibleHero__Button" key={i}>
          <Button
            icon
            type={'primary'}
            theme={'light'}
            href={button?.externalUrl}
            text={button?.text}
          />
        </span>
      ))}
    </div>
  )

  const eyebrow = (
    <Typography type={'labelAlt'} className="FlexibleHero__Eyebrow text">
      {formatInlineCode(data.eyebrow)}
    </Typography>
  )

  const headline = (
    <Typography type={'display'} className="FlexibleHero__Headline text">
      {formatInlineCode(data.headline)}
    </Typography>
  )

  const subheadline = (
    <Typography type={'lead'} className="FlexibleHero__Subheadline text">
      {formatInlineCode(heroSubheadline)}
    </Typography>
  )

  const keyData = (
    <Typography type={'header5'} className="FlexibleHero__KeyData text">
      {formatInlineCode(data.keyData)}
    </Typography>
  )

  return (
    <div className="FlexibleHero__Wrapper">
      <VerticalGrid
        className="FlexibleHero__VerticalGrid"
        $useCase={data.useCase}
        $isDarkTheme={data.theme === backgroundThemes.DARK}
        $showBreadcrumbs={showBreadcrumbs}>
        {data.logo && logo}
        {data.eyebrow && eyebrow}
        {data.headline && headline}
        {heroSubheadline && subheadline}
        {data.keyData && keyData}
        {data.cta && cta}
      </VerticalGrid>

      <MainImage
        className="FlexibleHero__MainImage_Container"
        $backgroundUrl={data.backgroundImage?.image?.file?.url || ''}
        $useCase={data.useCase}
        $showBreadcrumbs={showBreadcrumbs}>
        {data.mainImage && mainImage}
      </MainImage>
    </div>
  )
}
